enum RoutePath {
    HOME = '/',
    SERVICE = '/service'
}

export default RoutePath;
